<template>
	<div>
		<div class="step">
			<el-steps :active="active" finish-status="success" align-center>
				<el-step title="活动信息"></el-step>
				<el-step title="活动奖励"></el-step>
				<el-step title="活动二维码"></el-step>
			</el-steps>
		</div>
		<div v-if="active == 1">
			<payactivity ref="payactivity"></payactivity>
			<el-divider content-position='center'></el-divider>
			<reward ref="reward"></reward>
			<el-divider></el-divider>
			<promotions ref="promotions"></promotions>
			<div style="margin-left: 40%;margin-top: 20px;margin-bottom: 20px;">
				<el-button @click="previous">上一步</el-button>
				<el-button type="primary" @click="onsubmit">提 交</el-button>
			</div>
		</div>
		<div v-if="active == 2" class="qrcode">
			<div style="margin: 0;" id="qrcode" ref="qrcode"></div>
			<h1>抖音活动码</h1>
			<el-button
				type="primary"
				style="margin-top: 20px;"
				@click="
					$router.push(
						'/apply/newVip/13/market/marketing/client/activity_Douyin/index'
					)
				"
				>返回列表</el-button
			>
			<el-button
				type="text"
				style="margin-top: 20px;"
				@click="download_qrcode_method"
				>下载活动码</el-button
			>
		</div>
	</div>
</template>
<script>
import promotions from "@/views/apply/newVip/marketing/activity_Douyin/promotions";
import reward from "@/views/apply/newVip/marketing/activity_Douyin/reward";
import payactivity from "@/views/apply/newVip/marketing/activity_Douyin/pay_activity";

import { Douyin_detail, Douyin_detail2, reward_roles } from "@/api/Douyin";
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";

export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	components: {
		reward,
		promotions,
		payactivity,
	},
	data() {
		return {
			activeName: "first",
			active: 1,
			// form:{}
		};
	},
	mounted() {
		if (this.$route.query.key == "edit") {
			this.Detail();
		}
	},
	methods: {
		//上一步
		previous() {
			let key = "add";
			if (this.$route.query.key == "add") {
				key = "add";
			} else {
				key = "edit";
			}
			this.$router.push({
				path:
					"/apply/newVip/13/market/marketing/client/activity_Douyin/add_Douyin",
				query: {
					id: this.$route.query.id,
					key: key,
				},
			});
		},

		//下载抖音活动二维码
		download_qrcode_method(id) {
			try {
				var param =
					"?token=" +
					this.token +
					"&app_id=" +
					this.app_id +
					"&id=" +
					this.$route.query.id;
				var url1 =
					"https://www.58zltc.com/manage/douyin.activity/download_qrcode" +
					param;
				if (localStorage.getItem("baseStatus") == "test") {
					url1 =
						"https://cs.58zltc.com/manage/douyin.activity/download_qrcode" +
						param;
				}
				window.location.href = url1;
			} catch (e) {
				console.log(e);
			}
		},

		//详情
		async Detail() {
			try {
				const res = await Douyin_detail2({
					app_id: this.app_id,
					activity_id: this.$route.query.id,
				});
				if (res.code == 200) {
					console.log(res);
					let payactivity = this.$refs["payactivity"];
					payactivity.discount = res.data.discount;
					payactivity.is_pay = res.data.is_pay;
					payactivity.single_discount = res.data.single_discount;
					payactivity.type =
						res.data.discount.full_reduction == 1
							? "区间满减"
							: res.data.discount.every_reduction == 1
							? "每升满减"
							: "无限制";
					payactivity.type2 =
						res.data.discount.cate_offer == 1
							? "类别优惠"
							: res.data.discount.goods_offer == 1
							? "油品优惠"
							: "统一优惠";
					payactivity.discount.every_discount = Object.values(
						res.data.discount.every_discount
					);
					payactivity.discount.full_discount = Object.values(
						res.data.discount.full_discount
					);
					payactivity.discount.unified_offer_value =
						res.data.discount.unified_offer_value;
					this.$refs["reward"].is_reward = res.data.is_reward;
					this.$refs["reward"].form = res.data.reward;
					let arr = []
          res.data.reward_coupon_list.forEach((item,i)=>{
            arr.push({
              name:item.title,
              choseNum:item.num,
              id:item.id,
              imgUrl:'https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1576482532.jpg',
              url:'https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1576482532.jpg'
            })
          })
					this.$refs["reward"].couponLists = arr
					// this.$refs.reward.couponList_med();
					this.$refs["promotions"].is_prize = res.data.is_prize;
					this.$refs["promotions"].prize_id = res.data.prize_id;
					payactivity.mutex = res.data.mutex ? res.data.mutex.split(",") : [];

					switch (payactivity.type2) {
						case "统一优惠":
							payactivity.discount.unified_offer_value.discount = payactivity
								.discount.unified_offer_value.discount
								? Number(payactivity.discount.unified_offer_value.discount) / 10
								: "";
							break;
						case "类别优惠":
							payactivity.discount.cate_offer_value.forEach((item, i) => {
								item.discount = item.discount ? Number(item.discount) / 10 : "";
							});
							break;
						case "油品优惠":
							payactivity.discount.goods_offer_value.forEach((item, i) => {
								item.discount = item.discount ? Number(item.discount) / 10 : "";
							});
							break;
					}

					payactivity.discount.full_discount.forEach((item, i) => {
						switch (item.type) {
							case "统一优惠":
								item.unified_offer_value.discount = item.unified_offer_value
									.discount
									? Number(item.unified_offer_value.discount) / 10
									: "";
								break;
							case "类别优惠":
								item.cate_offer_value.forEach((items, i) => {
									items.discount = items.discount
										? Number(items.discount) / 10
										: "";
								});
								break;
							case "油品优惠":
								item.goods_offer_value.forEach((items, i) => {
									items.discount = items.discount
										? Number(items.discount) / 10
										: "";
								});
								break;
						}
					});
					payactivity.discount.every_discount.forEach((item, i) => {
						switch (item.type) {
							case "统一优惠":
								item.unified_offer_value.discount = item.unified_offer_value
									.discount
									? Number(item.unified_offer_value.discount) / 10
									: "";
								break;
							case "类别优惠":
								item.cate_offer_value.forEach((items, i) => {
									items.discount = items.discount
										? Number(items.discount) / 10
										: "";
								});
								break;
							case "油品优惠":
								item.goods_offer_value.forEach((items, i) => {
									items.discount = items.discount
										? Number(items.discount) / 10
										: "";
								});
								break;
						}
					});
				}
			} catch (e) {
				console.log(e);
			}
		},
		//提交
		onsubmit() {
			let payactivity = this.$refs["payactivity"];
			switch (payactivity.type) {
				case "无限制":
					payactivity.discount.full_reduction = 0;
					payactivity.discount.every_reduction = 0;
					switch (payactivity.type2) {
						case "统一优惠":
							payactivity.discount.unified_offer_value.discount = payactivity
								.discount.unified_offer_value.discount
								? Number(payactivity.discount.unified_offer_value.discount) * 10
								: "";
							payactivity.discount.unified_offer = 1;
							payactivity.discount.cate_offer = 0;
							payactivity.discount.goods_offer = 0;
							payactivity.discount.unified_offer_value.discount_status =
								payactivity.discount.unified_offer_value.type == 0 ? 1 : 0;
							payactivity.discount.unified_offer_value.money_status =
								payactivity.discount.unified_offer_value.type == 1 ? 1 : 0;
							break;
						case "类别优惠":
							payactivity.discount.unified_offer = 0;
							payactivity.discount.cate_offer = 1;
							payactivity.discount.goods_offer = 0;
							payactivity.discount.cate_offer_value.forEach((item, i) => {
								item.discount = item.discount ? Number(item.discount) * 10 : "";
								item.discount_status = item.type == 0 ? 1 : 0;
								item.money_status = item.type == 1 ? 1 : 0;
							});
							break;
						case "油品优惠":
							payactivity.discount.unified_offer = 0;
							payactivity.discount.cate_offer = 0;
							payactivity.discount.goods_offer = 1;
							payactivity.discount.goods_offer_value.forEach((item, i) => {
								item.discount = item.discount ? Number(item.discount) * 10 : "";
								item.discount_status = item.type == 0 ? 1 : 0;
								item.money_status = item.type == 1 ? 1 : 0;
							});
							break;
					}
					break;
				case "区间满减":
					payactivity.discount.unified_offer = 0;
					payactivity.discount.cate_offer = 0;
					payactivity.discount.goods_offer = 0;
					payactivity.discount.full_reduction = 1;
					payactivity.discount.every_reduction = 0;
					payactivity.discount.full_discount.forEach((item, i) => {
						switch (item.type) {
							case "统一优惠":
								item.unified_offer_value.discount = item.unified_offer_value
									.discount
									? Number(item.unified_offer_value.discount) * 10
									: "";
								item.cate_offer = 0;
								item.goods_offer = 0;
								item.unified_offer = 1;
								item.unified_offer_value.discount_status =
									item.unified_offer_value.type == 0 ? 1 : 0;
								item.unified_offer_value.money_status =
									item.unified_offer_value.type == 1 ? 1 : 0;
								item.unified_offer_value.dec_status =
									item.unified_offer_value.type == 2 ? 1 : 0;
								break;
							case "类别优惠":
								item.cate_offer = 1;
								item.goods_offer = 0;
								item.unified_offer = 0;
								item.cate_offer_value.forEach((e, i) => {
									e.discount = e.discount ? Number(e.discount) * 10 : "";
									e.discount_status = e.type == 0 ? 1 : 0;
									e.money_status = e.type == 1 ? 1 : 0;
									e.dec_status = e.type == 2 ? 1 : 0;
								});
								break;
							case "油品优惠":
								item.goods_offer = 1;
								item.cate_offer = 0;
								item.unified_offer = 0;
								item.goods_offer_value.forEach((e, i) => {
									e.discount = e.discount ? Number(e.discount) * 10 : "";
									e.discount_status = e.type == 0 ? 1 : 0;
									e.money_status = e.type == 1 ? 1 : 0;
									e.dec_status = e.type == 2 ? 1 : 0;
								});
								break;
						}
						// delete item.type;
					});
					break;
				case "每升满减":
					payactivity.discount.unified_offer = 0;
					payactivity.discount.cate_offer = 0;
					payactivity.discount.goods_offer = 0;
					payactivity.discount.full_reduction = 0;
					payactivity.discount.every_reduction = 1;
					payactivity.discount.every_discount.forEach((item, i) => {
						switch (item.type) {
							case "统一优惠":
								item.unified_offer_value.discount = item.unified_offer_value
									.discount
									? Number(item.unified_offer_value.discount) * 10
									: "";
								item.cate_offer = 0;
								item.goods_offer = 0;
								item.unified_offer = 1;
								item.unified_offer_value.discount_status =
									item.unified_offer_value.type == 0 ? 1 : 0;
								item.unified_offer_value.money_status =
									item.unified_offer_value.type == 1 ? 1 : 0;
								item.unified_offer_value.dec_status =
									item.unified_offer_value.type == 2 ? 1 : 0;
								break;
							case "类别优惠":
								item.cate_offer = 1;
								item.goods_offer = 0;
								item.unified_offer = 0;
								item.cate_offer_value.forEach((e, i) => {
									e.discount = e.discount ? Number(e.discount) * 10 : "";
									e.discount_status = e.type == 0 ? 1 : 0;
									e.money_status = e.type == 1 ? 1 : 0;
									e.dec_status = e.type == 2 ? 1 : 0;
								});
								break;
							case "油品优惠":
								item.goods_offer = 1;
								item.cate_offer = 0;
								item.unified_offer = 0;
								item.goods_offer_value.forEach((e, i) => {
									e.discount = e.discount ? Number(e.discount) * 10 : "";
									e.discount_status = e.type == 0 ? 1 : 0;
									e.money_status = e.type == 1 ? 1 : 0;
									e.dec_status = e.type == 2 ? 1 : 0;
								});
								break;
						}
						// delete item.type;
					});
					break;
				default:
					break;
			}
			if (typeof this.$refs["reward"].form.coupon == "object") {
				this.$refs["reward"].form.coupon = this.$refs[
					"reward"
				].form.coupon.join(",");
			}
			if (typeof this.$refs["promotions"].select == "object") {
				this.$refs["promotions"].select = this.$refs["promotions"].select.join(
					","
				);
			}

			if (payactivity.discount.every_discount instanceof Array) {
				payactivity.discount.every_discount = Object.fromEntries(
					payactivity.discount.every_discount.map((item) => [
						item.num || 0,
						item,
					])
				);
			}
			if (payactivity.discount.full_discount instanceof Array) {
				payactivity.discount.full_discount = Object.fromEntries(
					payactivity.discount.full_discount.map((item) => [
						item.num || 0,
						item,
					])
				);
			}
			console.log(typeof this.$refs["reward"].form.coupon);
			console.log("子组件", this.$refs["reward"].form);
			console.log("子组件", this.$refs["promotions"].select);
			console.log("子组件", this.$refs["payactivity"].discount);
			let data = {
				app_id: this.app_id,
				is_pay: payactivity.is_pay,
				single_discount: payactivity.single_discount,
				discount: payactivity.discount,
				is_reward: this.$refs["reward"].is_reward,
				reward: this.$refs["reward"].form,
				is_prize: this.$refs["promotions"].is_prize,
				prize_id: this.$refs["promotions"].prize_id || 0,
				activity_id: this.$route.query.id,
				mutex: payactivity.mutex.join(","),
			};
			console.log("data", data);
			reward_roles(data).then((res) => {
				console.log(res);
				payactivity.discount.every_discount = Object.values(
					payactivity.discount.every_discount
				);
				payactivity.discount.full_discount = Object.values(
					payactivity.discount.full_discount
				);
				if (res.code == 200) {
					this.$message.success(res.msg);
					this.active = 2;
					this.qrcode();
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		//二维码
		qrcode() {
			Douyin_detail({
				app_id: this.app_id,
				id: this.$route.query.id,
			}).then((res) => {
				if (res.code == 200) {
					let qrcode = new QRCode("qrcode", {
						width: 200, // 设置宽度，单位像素
						height: 200, // 设置高度，单位像素
						text: res.data.url, // 设置二维码内容或跳转地址
					});
				}
			});
		},
	},
};
</script>
<style lang="scss" scoped>
.step {
	width: 100%;
	height: 5vw;
	margin: 10px auto;
}
.qrcode {
	width: 200px;
	height: 200px;
	margin-left: 45%;
	text-align: center;
}
.el-divider--horizontal{
  width:70% !important;
  margin: 40px auto !important;
}
</style>
